import Colors from 'enums/Colors';

export const formatTitleWithIndex = (title: string, index: number) => {
    // Regex para capturar qualquer prefixo antes dos dois pontos
    const regex = /^\s*([^:]+)\s*:/i;
    const match = title.match(regex);
    if (match) {
        const prefix = match[1];
        const rest = title.replace(regex, '').trim();
        return `<label style="width: fit-content; font-size: 20px;">${prefix} ${index + 1} : </label> <span style="color:${
            Colors.Yellow
        }; ">${rest}</span>`;
    }
    return title;
};
export const formatTitleWithOrder = (title: string, order: number) => {
    // Regex para capturar qualquer prefixo antes dos dois pontos
    const regex = /^\s*([^:]+)\s*:/i;
    const match = title.match(regex);
    if (match) {
        const prefix = match[1];
        const rest = title.replace(regex, '').trim();
        return `<label style="width: fit-content; font-size: 20px;">${prefix} ${order} : </label> <span style="color:${Colors.Yellow}; ">${rest}</span>`;
    }
    return title;
};

export const formatTitleWithIndexSizeFontAll = (title: string, index: number) => {
    // Regex para capturar qualquer prefixo antes dos dois pontos
    const regex = /^\s*([^:]+)\s*:/i;
    const match = title.match(regex);
    if (match) {
        const prefix = match[1];
        const rest = title.replace(regex, '').trim();
        return `<label style="width: fit-content;">${prefix}: </label> <span style="color:${Colors.Yellow}; ">${rest}</span>`;
    }
    return title;
};
export const formatTitleWithRest = (title: string) => {
    // Regex para capturar qualquer prefixo antes dos dois pontos
    const regex = /^\s*([^:]+)\s*:/i;
    const match = title.match(regex);
    if (match) {
        const rest = title.replace(regex, '').trim();
        return `</label> <span style="color:${Colors.Yellow}; ">${rest}</span>`;
    }
    return title;
};

export const formatTitleWithPrefix = (title: string) => {
    // Regex para capturar qualquer prefixo antes dos dois pontos
    const regex = /^\s*([^:]+)\s*:/i;
    const match = title.match(regex);
    if (match) {
        const prefix = match[1];
        return `<label style="width: fit-content;">${prefix}</label>`;
    }
    return title;
};
export const formatTitleWithPrefixIndex = (title: string, index: number) => {
    // Regex para capturar qualquer prefixo antes dos dois pontos
    const regex = /^\s*([^:]+)\s*:/i;
    const match = title.match(regex);
    if (match) {
        const prefix = match[1];
        return `<label style="width: fit-content;">${prefix} ${index + 1} :</label>`;
    }
    return title;
};
